const B = "https://static.prod-images.emergentagent.com/jobs/53b99283-18a4-49a5-9889-4831576d758f/images/";
export const IMG = {
  heroFutures: `${B}1255ba0fab80463c7e3bb8deb94793d6c7606e7bac009de6c877f3e69b081b4f.jpeg`,
  wallet: `${B}f6b5676fba1778711308d90c71875ec8a03ea8bb157b86a355bb2c5a44221aca.jpeg`,
  trader: `${B}0fe94fdc79229d5760169413b45cd748dfdeebd29ad9e70cfea3c6bdacc1308e.jpeg`,
  referral: `${B}671185c009be4d150c114a6691a80fe4d9f7f1716a9754277487a5e4b3748211.jpeg`,
  phones: `${B}ea1fa2124355ecb2a192a05f3e0b551fe50d4ec57e4e4b00f62297e3d25e95c6.jpeg`,
  bars: `${B}2fc06dbdeddbc1d558c700a273cfe6f1bfacd80379c2eedbfaba0cb09eac5fd1.jpeg`,
  listingBg: `${B}2b74442c88e9b3bd75f9441543e0019288f4679b14a4b35e21e2acba271080a2.jpeg`,
};

// Uploaded images may be stored as "/api/..." paths when the CDN isn't configured.
export const resolveImg = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
